import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { AppConfig } from '../../../AppConfig';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { Helper } from '../../../common/helpers/Helper';
import { AppStyles } from '../../../styles/AppTheme';
import QrDialogContent from '../../../components/QrDialogContent';
import QRCode from 'qrcode';
import { PageDialog } from '../../../common/components/PageDialog';
import { SearchBar } from '../../../common/components/SearchBar';
import { buildWaNumberLabel, getWaOrgAccountNumbers } from './WhatsappUtils';


export class WhatsappNumbers extends BaseEntityPageSlixta {
  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = 'WhatsApp Numbers'
    this.pageKey = 'whatsapp-numbers'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.noAdd = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      {
        key: 'waAccounts',
        ms: this.ms,
        method: 'GET',
        paths: ['miscs', 'get-wa-accounts'],
        queryParams: { orgId: this.orgId },
      },
    ]
    this.apiData = {
      orgId: this.orgId,
    }
    this.tableHeadersMap = {
      Index: current => current.__index + 1,
      'WABA Number': current => (
        <div>
          <span className={css(Styles.line1)}>{buildWaNumberLabel(current.wabaNumber, this.waNumberDetails) || '—'}</span>
        </div>
      ),
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      },
    ]
    this.state = {
      ...this.state,
      waFromNumbers: [],
      masterNumberList: [],
      searchText: '',
      QrDialogOpen:false,
      qrCurrentNumber:null,
      waQrText:''
    }
  }

  fetchItems(onReadyCallback) {
    super.fetchItems(onReadyCallback)
  }

  async onFetchSuccess(results) {
    const waAccounts = this.getResult(results, 'waAccounts')
    const waOrgAccounts = waAccounts && waAccounts[this.orgId]
    const { fromNumbers, waNumberDetails } = getWaOrgAccountNumbers(waOrgAccounts)
    this.waNumberDetails = waNumberDetails
    const items = fromNumbers.map((wabaNumber, index) => ({
      id: `${this.orgId}_${wabaNumber}_${index}`,
      wabaNumber,
    }))

    this.setState({
      waFromNumbers: fromNumbers,
      masterNumberList: items,
      items,
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }
  onSearch(searchText=''){
    const search = String(searchText || '').trim().toLowerCase()
    if(!search){
        this.setState({
            items:this.state.masterNumberList
        })
        return
    }
    const items = (this.state.masterNumberList || []).filter(row => {
      const phone = String(row.wabaNumber || '').toLowerCase()
      const label = buildWaNumberLabel(row.wabaNumber, this.waNumberDetails).toLowerCase()
      return phone.includes(search) || label.includes(search)
    })
    this.setState({
        items,
    })
  }
  clearSearch(){
    this.setState({
        items: this.state.masterNumberList || []
    })
  }
  buildWaQrLink(current,messageText='') {
    const number = String(current && current.wabaNumber ?  current.wabaNumber : '').replace(/\D/g, '')
    if(!number) return ''
    const base = `https://wa.me/${number}`
    const text = String(messageText || '').trim()
    if (!text) return base
    return `${base}?text=${encodeURIComponent(text)}`
  }

  async generateQr(url) {
    if(!url) {
      this.setState({qrDataUrl:null})
      return
    }
    try{
      const dataUrl = await QRCode.toDataURL(url, {
        width: 300,
        margin: 2,
        color: { dark: '#000000', light: '#00000000' },
        errorCorrectionLevel: 'H',
      })
      this.setState({qrDataUrl:dataUrl})
    }catch(e) {
      this.setState({qrDataUrl:null})
    }
  }
  openQrDialog(current) {
    const defaultText=''
    const url = this.buildWaQrLink(current,defaultText)
    this.setState(
      {
        qrDialogOpen: true,
        qrCurrentNumber: current,
        qrDataUrl: null,
      },
      () => this.generateQr(url)
    )
  }
  
  closeQrDialog() {
    this.setState({
      qrDialogOpen:false,
      qrCurrentNumber:null,
      qrDataUrl:null,
      waQrText:''
    })
  }
  handleTextChange(value){
    this.setState(
        {waQrText:value},
        () => {
            const url = this.buildWaQrLink(this.state.qrCurrentNumber,this.state.waQrText)
            this.generateQr(url)
        }
    )
  }
  downloadQr() {
    const { qrCurrentNumber , waQrText} = this.state
    if (!qrCurrentNumber) return

    const url = this.buildWaQrLink(qrCurrentNumber,waQrText)
    QRCode.toDataURL(url, {
      width: 1920,
      margin: 2,
      color: { dark: '#000000', light: '#00000000' },
      errorCorrectionLevel: 'H',
    }).then(dataUrl => {
      const a = document.createElement('a')
      a.href = dataUrl
      a.download = `${qrCurrentNumber.wabaNumber || 'whatsapp'}-qr.png`
      a.click()
    })
  }
  renderQrDialog() {
    return (
      <PageDialog
        isOpen={this.state.qrDialogOpen}
        title='Generate QR Code'
        onClosed={() => this.closeQrDialog()}
        fullWidth
        maxWidth='md'
        PageComponent={QrDialogContent}
        PageComponentProps={{
          page: this.state.qrCurrentNumber,
          qrDataUrl: this.state.qrDataUrl,
          inputValue:this.state.waQrText,
          inputLabel:'Text',
          inputHint:'Message to prefill in WhatsApp',
          onInputChange:value => this.handleTextChange(value),
          onDownload: () => this.downloadQr(),
          buildFullLink: page => this.buildWaQrLink(page,this.state.waQrText),
          showAdvanced: false,
          showCopyLink: true,
          onCopyLink: () =>{
            if (!Helper.isAndroidDevice()) {
              this.setState({
                showToast: true,
                isErrorToast: false,
                toastMsg: 'Copied to clipboard',
              })
            }
          },
        }}
      />
    )
  }
  renderAboveTable() {
    return (
      <SearchBar
        hint='Search by WABA number'
        onSearch={this.onSearch.bind(this)}
        onClearSearch={this.clearSearch.bind(this)}
        searchText={this.state.searchText}
        searchButtonLabel='Search'
        clearSearchLabel='Clear Search'
        autoRefresh
        debounceDuration={1}
        autoFocus={true}
      >
      </SearchBar>
    );
  }
  renderBelowTable() {
    return this.renderQrDialog()
  }
  onActions = (current) => {
    const actions = []
    actions.push(
      <Tooltip title='Generate QR Code' placement='top-start' key={`${current.id}-qr`}>
        <span
          className={css(AppStyles.entityTableLinkIcon, Styles.entityTableLinkIcon, Styles.qrIconWrapper)}
          onClick={() => this.openQrDialog(current)}
        >
          <i className='material-icons-outlined'>qr_code_2</i>
        </span>
      </Tooltip>
    )
    return actions
  }
}
const Styles = StyleSheet.create({
  line2: {
    fontSize: 14,
    color: 'gray',
  },
  line1: {
    fontSize: 16,
  },
  entityTableLinkIcon: {
    cursor: 'pointer',
  },
  qrIconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
